module.exports = __webpack_public_path__ + "static/img/icon_paypal.2a51ee91.png";